/// <reference lib="dom" />
// @ts-nocheck
import React, { useState, useRef } from 'react';
import { Container, Typography, Box, TextField, Button, IconButton } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';

interface DescribeIssueProps {
  prompt: string;
  onSubmit: (description: string) => void;
}

// Type definitions for SpeechRecognition and SpeechRecognitionEvent
type SpeechRecognition = typeof window.webkitSpeechRecognition;
type SpeechRecognitionEvent = typeof window.webkitSpeechRecognitionEvent;

const DescribeIssue: React.FC<DescribeIssueProps> = ({ prompt, onSubmit }) => {
  const [description, setDescription] = useState('');
  const recognitionRef = useRef<InstanceType<SpeechRecognition> | null>(null);

  // Initialize Speech Recognition
  if (!recognitionRef.current && 'webkitSpeechRecognition' in window) {
    const SpeechRecognition = window.webkitSpeechRecognition as SpeechRecognition;
    recognitionRef.current = new SpeechRecognition();
    recognitionRef.current.continuous = false;
    recognitionRef.current.interimResults = false;
    recognitionRef.current.lang = 'en-US';
    recognitionRef.current.onresult = (event: InstanceType<SpeechRecognitionEvent>) => {
      setDescription(event.results[0][0].transcript);
    };
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDescription(event.target.value);
  };

  const handleSpeechInput = () => {
    recognitionRef.current?.start();
  };

  const handleSubmit = () => {
    onSubmit(description);
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ mt: 4, width: '100%' }}>
        <Typography component="h1" variant="h5" gutterBottom>
          {prompt}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Describe your issue"
            variant="outlined"
            value={description}
            onChange={handleChange}
            multiline
            rows={2}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={handleSpeechInput} edge="end">
                  <MicIcon />
                </IconButton>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, py: 2, fontSize: '1.25rem' }}
            onClick={handleSubmit}
            disabled={!description.trim()} // Disable button if description is empty or only whitespace
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default DescribeIssue;
